import { Button, Checkbox, Tooltip } from "@mui/material";
import AdjustButtons from "src/components/buttons/AdjustButtons";
import { useReportData } from "src/context/ReportContext";
import PropTypes from "prop-types";
import MyDivider from "src/components/layout/MyDivider";

const styles = {
  checkBoxContainer: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "flex-end",
    width: "100%",
  },
  checkBoxesContainer: {
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-end",
    justifyContent: "center",
  },
  rightContainer: {
    display: "flex",
    flexDirection: "column",
    width: "50%",
  },
  leftContainer: { flexDirection: "column", paddingLeft: 8, paddingRight: 8 },
  mainContainer: { display: "flex", alignItems: "flex-start", justifyContent: "center" },
  resetContainer: {
    paddingTop: 8,
    display: "flex",
    justifyContent: "flex-end",
  },
};

export default function Report_Settings() {
  const { settingsData, setSettingsData } = useReportData();

  const handleAdjustBodyFontSize = (value) => {
    const newValue = settingsData.bodyFontSize + value;
    setSettingsData({ ...settingsData, bodyFontSize: Math.max(newValue, 0) });
  };
  const handleAdjustTitleFontSize = (value) => {
    const newValue = settingsData.titleFontSize + value;
    setSettingsData({ ...settingsData, titleFontSize: Math.max(newValue, 0) });
  };
  const handleAdjustDriverSpacing = (value) => {
    const newValue = settingsData.driverSpacing + value;
    setSettingsData({ ...settingsData, driverSpacing: Math.max(newValue, 0) });
  };
  const handleAdjustRowSpacing = (value) => {
    const newValue = settingsData.rowSpacing + value;
    setSettingsData({ ...settingsData, rowSpacing: Math.max(newValue, 0) });
  };
  const handleKommentCheckboxChange = (e) =>
    setSettingsData({ ...settingsData, showComments: e.target.checked });
  const handleSourceCheckboxChange = (e) =>
    setSettingsData({ ...settingsData, showSource: e.target.checked });
  const handleResetClick = () => setSettingsData(null);

  return (
    <div>
      <div style={styles.mainContainer}>
        <div className="center" style={styles.leftContainer}>
          <SettingsRow
            label="Otsikon fonttikoko:"
            value={settingsData.titleFontSize}
            onAdjust={handleAdjustTitleFontSize}
          />
          <SettingsRow
            label="Tekstin fonttikoko:"
            value={settingsData.bodyFontSize}
            onAdjust={handleAdjustBodyFontSize}
          />
          <SettingsRow
            label="Ryhmäväli:"
            value={settingsData.driverSpacing}
            onAdjust={handleAdjustDriverSpacing}
          />
          <SettingsRow
            label="Riviväli:"
            value={settingsData.rowSpacing}
            onAdjust={handleAdjustRowSpacing}
          />
        </div>
        .
        <div style={styles.rightContainer}>
          <div style={styles.checkBoxesContainer}>
            <div style={styles.checkBoxContainer}>
              Kommentit{" "}
              <Checkbox
                checked={settingsData.showComments || false}
                onChange={handleKommentCheckboxChange}
                color="primary"
                size="small"
              />
            </div>
            <Tooltip
              disableInteractive
              title="Näytä tilauksen lähdeasiakas; mistä tilaus on saapunut">
              <div style={styles.checkBoxContainer}>
                Lähde{" "}
                <Checkbox
                  checked={settingsData.showSource || false}
                  onChange={handleSourceCheckboxChange}
                  color="primary"
                  size="small"
                />
              </div>
            </Tooltip>
          </div>
        </div>
      </div>
      <MyDivider />
      <div style={styles.resetContainer}>
        <Button variant="outlined" onClick={handleResetClick}>
          PALAUTA OLETUSASETUKSET
        </Button>
      </div>
    </div>
  );
}

const SettingsRow = ({ label, value, onAdjust }) => (
  <div style={{ display: "flex", alignItems: "center" }}>
    <div style={{ width: 150 }}>{label}</div>
    <div>
      <AdjustButtons onAdjust={onAdjust} isIncrement={false} includeHalf={false} />
    </div>
    <div className="center" style={{ width: 30 }}>
      {value}
    </div>
    <div>
      <AdjustButtons onAdjust={onAdjust} isIncrement={true} includeHalf={false} />
    </div>
  </div>
);

SettingsRow.propTypes = {
  label: PropTypes.string.isRequired,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  onAdjust: PropTypes.func.isRequired,
};
